<template>
  <div class="d-block" v-if="modalShow">
    <v-dialog
      v-model="modalShow"
      data-test="welcome-popup-modal"
      class="registerModal"
      ref="registerModal"
      hide-header
      hide-footer
      centered
      body-class="p-0"
      scroll-strategy="none"
      :transition="'fade-transition'"
      @hidden="close"
      :fullscreen="form.welcome_message_type_id == 3"
      :close-on-content-click="form.welcome_message_type_id == 3"
    >
      <template v-if="form.welcome_message_type_id == 2">
        <font-awesome-icon
          icon="times"
          class="page-nav"
          @click="close"
          data-test="welcome-popup-close-icon"
        ></font-awesome-icon>
        <div class="text-center p-3">
          <div class="f-bold f-size-18">
            {{ form.welcome_popup[0].title }}
          </div>
          <c-img-lazy
            v-bind="mainProps"
            :src="form.image_url"
            class="lazy-image rounded-5xem mb-3"
            alt="Image 1"
          ></c-img-lazy>
          <div>{{ form.welcome_popup[0].description }}</div>
        </div>
        <div class="btn-confirm-popup">
          <c-btn
            variant="primary-theme"
            class="w-100"
            @click="buttonAction"
            style="flex: 1"
            data-test="welcome-popup-action-btn"
            >{{ form.welcome_popup[0].button_name }}</c-btn
          >
        </div>
      </template>
      <template v-else-if="form.welcome_message_type_id == 3">
        <font-awesome-icon
          icon="times"
          class="page-nav"
          @click="close"
          data-test="welcome-popup-close-icon"
        ></font-awesome-icon>
        <div class="text-center welcome-screen">
          <img
            :src="form.image_url"
            class="background-image"
            alt="Welcome Image"
          />
          <div>
            <div
              class="f-bold"
              :style="`font-size: ${form.font_size_title || 24}px;`"
            >
              {{ form.welcome_popup[0].title }}
            </div>

            <div :style="`font-size: ${form.font_size_description || 32}px;`">
              {{ form.welcome_popup[0].description }}
            </div>
          </div>
        </div>
        <div class="welcome-popup-button" v-if="form.is_display_button == 1">
          <c-btn
            variant="primary-theme"
            class="w-100"
            @click="buttonAction"
            style="flex: 1"
            data-test="welcome-popup-action-btn"
            >{{ form.welcome_popup[0].button_name }}
          </c-btn>
          <!-- <b-button data-lang="close_window" variant="">{{ $t("close_window") }}</b-button> -->
        </div>
      </template>
      <template v-else>
        <div class="text-center p-3">
          <div class="f-bold f-size-18" v-if="form.welcome_popup">
            {{ form.welcome_popup[0].title }}
          </div>
          <div class="f-bold f-size-18" v-else>
            {{ form[0].title }}
          </div>
          <div v-if="form.welcome_popup">
            {{ form.welcome_popup[0].description }}
          </div>
          <div v-else>{{ form[0].description }}</div>
        </div>
        <div class="border-top p-2 text-center btn-confirm-popup">
          <div data-lang="close_window" @click="close" data-test="welcome-popup-close-btn">{{ $t("close_window") }}</div>
        </div>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import WelcomeScreenMinimalTheme from "@/components/profile/modal/WelcomeScreenMinimalTheme";
export default {
  components: { WelcomeScreenMinimalTheme },
  props: {
    form: {
      required: true
    }
  },
  data() {
    return {
      modalShow: false,
      lineProfile: {
        displayName: ""
      },
      detail: []
    };
  },
  watch: {
    modalShow(newVal) {
      if (!newVal) {
        // console.log("Dialog ปิดแล้ว");
        this.$cookies.set("popupModalRegister", false);
      }
    }
  },

  methods: {
    async show() {
      console.log("object");
      this.modalShow = true;
    },
    close() {
      this.modalShow = false;
      this.$cookies.set("popupModalRegister", false);
    },
    buttonAction() {
      if (this.form.welcome_message_type_id == 2)
        window.open(this.form.url, "_blank");
      this.modalShow = false;
      this.$cookies.set("popupModalRegister", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-body {
  margin: auto;
  text-align: center;
}
.image-logo {
  width: 100%;
  height: 100%;
}
.welcome-screen {
  height: 100dvh;
  width: 100%;
  background-image: ""; /* เปลี่ยนเป็น path จริง */
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.welcome-popup-button {
  position: absolute;
  bottom: 0;
  padding: 2rem 1rem;
  width: 100%;
  left: 0;
}
</style>
